import * as types from '../mutation-types'
import s from '../state'
import api from '@/api'
import axios from 'axios'
import {Message} from 'element-ui'
import router from '../../router'
import c from '@/common/js'

const state = {
  orders: [], 
  orderDetail: {}, 
  orderCurrentPage: 0, // 当前页数
  orderTotal:0,
  orderStatus:0
}

const getters = {
    orders: state => state.orders,
    orderDetail: state => state.orderDetail,
    orderTotal:state => state.orderTotal,
    orderCurrentPage: state => state.orderCurrentPage,
    orderStatus: state => state.orderStatus
}
const actions = {
  // 加载列表
  async loadOrderList({commit, state}, quit = false) {
    
    await api.get(`order?status=${state.orderStatus}&page=${state.orderCurrentPage + 1}`).then(response => {
      // 获取列表数据
      commit(types.LOAD_ORDER_LIST, response.data.data)
      // 获取当前页数
      commit(types.STORE_ORDER_CURRENTPAGE, response.data.current_page)

      commit(types.STORE_ORDER_TOTAL, response.data.total)
    }).catch(error => {
     
      Message({message: '抱歉，服务器开了个小差', type: 'error', customClass: 'c-msg', duration: 0, showClose: true})
      Promise.reject(error)
    })
  },
  
  async loadOrder({commit}, path) {
    // 获取详情
    await api.get(path).then(response => {
      if (response.data.error) {
        response.data.error.http_code === 404 && router.push({name: '404'})
      }
      commit(types.LOAD_ORDER_DETAIL, response.data)
     
    }).catch(error => {
      commit(types.TOGGLE_LOADING_STATUS)
      Message({message: '抱歉，服务器开了个小差', type: 'error', customClass: 'c-msg', duration: 0, showClose: true})
      Promise.reject(error)
    })
  },
  
  storeOrderCurrentPage({commit}, currentPage) {
    commit(types.STORE_ORDER_CURRENTPAGE, currentPage)
  },
  storeOrderStatus({commit}, orderStatus) {
    commit(types.STORE_ORDER_STATUS, orderStatus)
  },
  
}
const mutations = {
  [types.LOAD_ORDER_LIST](state, orders) {
    if (!state.orderCurrentPage) {
      state.orders = orders
    } else {
      state.orders = state.orders.concat(orders)
    }
    //console.log(state.orders)
  },
  [types.LOAD_ORDER_DETAIL](state, orderDetail) {
    state.orderDetail = orderDetail
  },
  [types.STORE_ORDER_CURRENTPAGE](state, currentPage) {
    state.orderCurrentPage = currentPage
  },
  [types.STORE_ORDER_TOTAL](state, orderTotal) {
    state.orderTotal = orderTotal
  },
  [types.STORE_ORDER_STATUS](state, orderStatus) {
    state.orderStatus = orderStatus
  },
}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js